/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		4: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"2":"route-articles","3":"route-home"}[chunkId]||chunkId) + ".chunk." + {"0":"4b46d","1":"1c926","2":"d0347","3":"62525"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "kEqy");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "/x+s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Head; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* @jsx h */


var DOMAttributeNames = {
  acceptCharset: 'accept-charset',
  className: 'class',
  htmlFor: 'for',
  httpEquiv: 'http-equiv'
};

var browser = typeof window !== 'undefined';
var mounted = [];

function reducer(components) {
  return components.map(function (c) {
    return c.children;
  }).filter(function (c) {
    return !!c;
  }).reduce(function (a, b) {
    return a.concat(b);
  }, []).reverse().filter(unique()).reverse().map(function (c) {
    var className = (c.className ? c.className + ' ' : '') + 'preact-head';
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(c, { className: className });
  });
}

function updateClient(head) {
  var tags = {};
  head.forEach(function (h) {
    var components = tags[h.nodeName] || [];
    components.push(h);
    tags[h.nodeName] = components;
  });

  updateTitle(tags.title ? tags.title[0] : null);

  var types = ['meta', 'base', 'link', 'style', 'script'];
  types.forEach(function (type) {
    updateElements(type, tags[type] || []);
  });
}

function updateElements(type, components) {
  var headEl = document.getElementsByTagName('head')[0];
  var oldTags = Array.prototype.slice.call(headEl.querySelectorAll(type + '.preact-head'));
  var newTags = components.map(domify).filter(function (newTag) {
    for (var i = 0, len = oldTags.length; i < len; i++) {
      var oldTag = oldTags[i];
      if (oldTag.isEqualNode(newTag)) {
        oldTags.splice(i, 1);
        return false;
      }
    }
    return true;
  });

  oldTags.forEach(function (t) {
    return t.parentNode.removeChild(t);
  });
  newTags.forEach(function (t) {
    return headEl.appendChild(t);
  });
}

function domify(component) {
  var el = document.createElement(component.nodeName);
  var attrs = component.attributes || {};
  var children = component.children;

  for (var p in attrs) {
    if (!attrs.hasOwnProperty(p)) continue;
    if (p === 'dangerouslySetInnerHTML') continue;

    var attr = DOMAttributeNames[p] || p.toLowerCase();
    el.setAttribute(attr, attrs[p]);
  }

  if (attrs['dangerouslySetInnerHTML']) {
    el.innerHTML = attrs['dangerouslySetInnerHTML'].__html || '';
  } else if (children) {
    el.textContent = typeof children === 'string' ? children : children.join('');
  }

  return el;
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];

// returns a function for filtering head child elements
// which shouldn't be duplicated, like <title/>.
function unique() {
  var tags = [];
  var metaTypes = [];
  var metaCategories = {};
  return function (h) {
    switch (h.nodeName) {
      case 'title':
      case 'base':
        if (~tags.indexOf(h.nodeName)) return false;
        tags.push(h.nodeName);
        break;
      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.attributes.hasOwnProperty(metatype)) continue;
          if (metatype === 'charSet') {
            if (~metaTypes.indexOf(metatype)) return false;
            metaTypes.push(metatype);
          } else {
            var category = h.attributes[metatype];
            var categories = metaCategories[metatype] || [];
            if (~categories.indexOf(category)) return false;
            categories.push(category);
            metaCategories[metatype] = categories;
          }
        }
        break;
    }
    return true;
  };
}

function updateTitle(component) {
  var title = void 0;
  if (component) {
    var children = component.children;

    title = typeof children === 'string' ? children : children.join('');
  } else {
    title = '';
  }
  if (title !== document.title) {
    document.title = title;
  }
}

function update() {
  var state = reducer(mounted.map(function (mount) {
    return mount.props;
  }));
  if (browser) updateClient(state);
}

var Head = function (_Component) {
  _inherits(Head, _Component);

  function Head() {
    _classCallCheck(this, Head);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Head.rewind = function rewind() {
    var state = reducer(mounted.map(function (mount) {
      return mount.props;
    }));
    mounted = [];
    return state;
  };

  Head.prototype.componentDidUpdate = function componentDidUpdate() {
    update();
  };

  Head.prototype.componentWillMount = function componentWillMount() {
    mounted.push(this);
    update();
  };

  Head.prototype.componentWillUnmount = function componentWillUnmount() {
    var i = mounted.indexOf(this);
    if (~i) mounted.splice(i, 1);
    update();
  };

  Head.prototype.render = function render() {
    return null;
  };

  return Head;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/preact-head/index.js
var preact_head = __webpack_require__("/x+s");

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ../node_modules/unistore/preact.js
var preact = __webpack_require__("o6ac");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// EXTERNAL MODULE: ./store/actions.js + 1 modules
var actions = __webpack_require__("QlVn");

// CONCATENATED MODULE: ./components/header/index.js


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import style from "./style";

var headerSt = {
  backgroundColor: "#3b1f6d",
  padding: "0.4rem 0"
};
var headcolorSt = {
  color: "#3b1f6d"
};
var rightLinkSt = {
  marginRight: "0.4rem",
  fontSize: "1rem",
  color: "#fff"
};

var brandSt = {
  color: "#fff"
};

var navbarLeft = {
  width: "33%",
  display: "inline-block",
  color: "#fff",
  padding: "10px"
};

var navbarCenter = {
  width: "33%",
  margin: "0 auto",
  textAlign: "center",
  display: "inline-block"
};

var navbarRight = {
  width: "33%",
  display: "inline-block",
  color: "#fff",
  padding: "10px",
  textAlign: "right"
};

var _ref2 = Object(preact_min["h"])(
  "div",
  { id: "header", style: headerSt },
  Object(preact_min["h"])(
    "header",
    { "class": "navbar" },
    Object(preact_min["h"])(
      "section",
      { "class": "navbar-section text-primary", style: navbarLeft },
      "menu"
    ),
    Object(preact_min["h"])(
      "section",
      { "class": "navbar-center", style: navbarCenter },
      Object(preact_min["h"])(
        match["Link"],
        { href: "/", "class": "btn btn-noborder btn-transparent text-light", style: brandSt },
        "WWWID"
      )
    ),
    Object(preact_min["h"])(
      "section",
      { "class": "navbar-section", style: navbarRight },
      Object(preact_min["h"])(
        "a",
        {
          "class": "btn btn-noborder btn-transparent text-light rightpos",
          href: "https://github.com/azulkipli/preact-wwwidpwa",
          target: "_blank",
          role: "button",
          "aria-label": "github",
          rel: "noopener",
          style: rightLinkSt
        },
        Object(preact_min["h"])("i", { "class": "icon icon-link" }),
        " repo"
      )
    )
  )
);

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Header.prototype.render = function render(props, _ref) {
    _objectDestructuringEmpty(_ref);

    return _ref2;
  };

  return Header;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/clock/index.js


function clock__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function clock__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function clock__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var clock_Clock = function (_Component) {
  clock__inherits(Clock, _Component);

  function Clock() {
    clock__classCallCheck(this, Clock);

    // set initial time:
    var _this = clock__possibleConstructorReturn(this, _Component.call(this));

    _this.state.time = Date.now();

    _this.state.year = new Date(Date.now()).getFullYear("Y");
    return _this;
  }

  Clock.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // update time every second
    this.timer = setInterval(function () {
      _this2.setState({ time: Date.now() });
    }, 1000);
  };

  Clock.prototype.componentWillUnmount = function componentWillUnmount() {
    // stop when not renderable
    clearInterval(this.timer);
  };

  Clock.prototype.render = function render(props, state) {
    var time = new Date(state.time).toLocaleTimeString("id");
    return Object(preact_min["h"])(
      "div",
      { "class": "text-center" },
      "built with",
      Object(preact_min["h"])(
        "span",
        { lang: "ar", style: { margin: "0 6px", fontSize: "17px", fontWeight: "bolder" } },
        "\u0628\u0633\u0645 \u0627\u0644\u0644\u0647"
      ),
      "by azul \xA9 ",
      state.year
    );
  };

  return Clock;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/error/index.js


var error__ref2 = Object(preact_min["h"])(
  "p",
  null,
  "URL not found."
);

var error_Error = function Error(_ref) {
  var type = _ref.type,
      url = _ref.url;
  return Object(preact_min["h"])(
    "div",
    { id: "error" },
    Object(preact_min["h"])(
      "h1",
      { "class": "h6 my-6 text-center" },
      "Ups ",
      type
    ),
    Object(preact_min["h"])(
      "div",
      { className: "p-1" },
      type === "404" ? error__ref2 : "",
      Object(preact_min["h"])(
        "pre",
        null,
        url
      )
    )
  );
};

/* harmony default export */ var error = (error_Error);
// CONCATENATED MODULE: ./components/modal/index.js


function modal__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function modal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function modal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function modal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var modal_Modal = function (_Component) {
  modal__inherits(Modal, _Component);

  function Modal() {
    modal__classCallCheck(this, Modal);

    return modal__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Modal.prototype.render = function render(props, _ref) {
    modal__objectDestructuringEmpty(_ref);

    // console.log("Modal props", props);
    var clsModal = props.modalActive ? "modal active" : "modal";
    return Object(preact_min["h"])(
      "div",
      { "class": clsModal, id: "smodal" },
      Object(preact_min["h"])("a", { "class": "modal-overlay", "aria-label": "Close", onClick: props.hideModal }),
      Object(preact_min["h"])(
        "div",
        { "class": "modal-container" },
        Object(preact_min["h"])(
          "div",
          { "class": "modal-header" },
          Object(preact_min["h"])("a", { "class": "btn btn-clear float-right", "aria-label": "Close", onClick: props.hideModal }),
          Object(preact_min["h"])(
            "div",
            { "class": "modal-title h5" },
            props.modalTitle
          )
        ),
        Object(preact_min["h"])(
          "div",
          { "class": "modal-body" },
          Object(preact_min["h"])(
            "div",
            { "class": "content" },
            props.modalContent
          )
        )
      )
    );
  };

  return Modal;
}(preact_min["Component"]);

/* harmony default export */ var modal = (Object(preact["connect"])("modalActive, modalTitle, modalContent", actions["a" /* default */])(modal_Modal));
// EXTERNAL MODULE: /Users/azul/.nvm/versions/node/v8.9.1/lib/node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("pj7R");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: /Users/azul/.nvm/versions/node/v8.9.1/lib/node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./routes/home/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("whsi") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var home = (async_default()(load));
	
// CONCATENATED MODULE: /Users/azul/.nvm/versions/node/v8.9.1/lib/node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./routes/articles/index.js

		

		function articles_load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function (require) {
				cb( __webpack_require__("N5nc") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var articles = (async_default()(articles_load));
	
// CONCATENATED MODULE: ./components/app.js


function app__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import FontAwesomeIcon from "@fortawesome/react-fontawesome";
// import faBars from "@fortawesome/fontawesome-free-solid/faBars";



// Unistore


// Unistore

// Components

// import Drawer from "./drawer";



// import Home from "../routes/home";
// import Profile from "../routes/profile";


// import Profile from "async!../routes/profile";
// Components

// Hotreload
if (false) {
  require("preact/debug");
}
// Hotreload

var jsUcfirst = function jsUcfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
// Utils

var appStyle = {
  height: "100%"
};

var appcontainerStyle = {
  height: "100%",
  padding: "0 15px",
  marginBottom: "50px"
};

var app__ref2 = Object(preact_min["h"])(
  preact_head["a" /* default */],
  null,
  Object(preact_min["h"])(
    "title",
    null,
    "PreactJS WWWIDPWA"
  ),
  Object(preact_min["h"])("meta", { name: "description", content: "Progressive Web App using PreactJS" }),
  Object(preact_min["h"])("meta", {
    name: "keywords",
    content: "pwa, preact, unistore, netlify, code-splitting, hot-reload, wwwid, medium-app"
  }),
  Object(preact_min["h"])("meta", { name: "author", content: "Azul" })
);

var _ref3 = Object(preact_min["h"])(
  "header",
  null,
  Object(preact_min["h"])("label", { "for": "drawer-checkbox", "class": "button drawer-toggle" }),
  Object(preact_min["h"])(
    match["Link"],
    { "class": "logo", href: "/" },
    "WWWID"
  )
);

var _ref4 = Object(preact_min["h"])("label", { "for": "drawer-checkbox" });

var _ref5 = Object(preact_min["h"])("input", { type: "checkbox", id: "drawer-checkbox", "aria-label": "btnDrawer", name: "btndrawer" });

var _ref6 = Object(preact_min["h"])(
  "div",
  { "class": "drawer" },
  Object(preact_min["h"])("label", { "for": "drawer-checkbox", "class": "close" }),
  Object(preact_min["h"])(
    match["Link"],
    { href: "/" },
    "Home"
  )
);

var _ref7 = Object(preact_min["h"])(home, { path: "/" });

var _ref8 = Object(preact_min["h"])(articles, { path: "/articles/:slug" });

var _ref9 = Object(preact_min["h"])(error, { type: "404", "default": true });

var _ref10 = Object(preact_min["h"])(
  "footer",
  null,
  Object(preact_min["h"])(clock_Clock, null)
);

var app_App = function (_Component) {
  app__inherits(App, _Component);

  function App() {
    var _temp, _this, _ret;

    app__classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = app__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleRoute = function (e) {
      _this.currentUrl = e.url;
    }, _this.goTo = function (pathname) {
      Object(preact_router_es["route"])(pathname);
      if (_this.props.drawerActive) {
        _this.props.hideDrawer();
      }
    }, _temp), app__possibleConstructorReturn(_this, _ret);
  }
  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */


  App.prototype.render = function render(props, _ref) {
    app__objectDestructuringEmpty(_ref);

    console.log("App Router", preact_router_es["Router"]);
    var currentUrl = preact_router_es["Router"].getCurrentUrl();
    var paths = currentUrl.split("/");
    var curPath = paths[1] === "" ? "Home" : jsUcfirst(paths[1]);
    return Object(preact_min["h"])(
      "div",
      { id: "app", style: appStyle },
      app__ref2,
      _ref3,
      _ref4,
      _ref5,
      _ref6,
      Object(preact_min["h"])(
        preact_router_es["Router"],
        { onChange: this.handleRoute },
        _ref7,
        _ref8,
        _ref9
      ),
      _ref10
    );
  };

  return App;
}(preact_min["Component"]);

// export default App;


/* harmony default export */ var app = (Object(preact["connect"])("count, login, modalActive, modalTitle, modalContent, drawerActive", actions["a" /* default */])(app_App));
// EXTERNAL MODULE: ../node_modules/unistore/full/preact.js
var full_preact = __webpack_require__("jrcW");
var full_preact_default = /*#__PURE__*/__webpack_require__.n(full_preact);

// EXTERNAL MODULE: ../node_modules/unistore/devtools.js
var unistore_devtools = __webpack_require__("kvQY");
var devtools_default = /*#__PURE__*/__webpack_require__.n(unistore_devtools);

// CONCATENATED MODULE: ./store/initState.js
// init store
var initState_initState = {
  count: 0,
  login: false,
  drawerActive: false,
  modalActive: false,
  loadingRSSFeed: true,
  listRSSwwwid: [],
  modalTitle: "Default Modal Title",
  modalContent: "Default modal content is here, because didn't pass `content` argument"
};

/* harmony default export */ var store_initState = (initState_initState);
// CONCATENATED MODULE: ./index.js






// import "../spectre/dist/spectre.min.css";
// import "../spectre/dist/spectre-exp.min.css";
// import "../spectre/dist/spectre-icons.min.css";

// import "./style";

// adds memory backing to a unistore store instance:
function addMemory(store) {
  if (window.STATE) store.setState(window.STATE);
  store.subscribe(function (state) {
    window.STATE = state;
  });
}

var store =  true ? Object(full_preact["createStore"])(store_initState) : devtools(createStore(initState));
addMemory(store);

var index__ref = Object(preact_min["h"])(
  full_preact["Provider"],
  { store: store },
  Object(preact_min["h"])(app, null)
);

/* harmony default export */ var index = __webpack_exports__["default"] = (function () {
  return index__ref;
});

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink\:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "QlVn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/unistore/dist/unistore.es.js
function n(n, t) {
  for (var u in t) {
    n[u] = t[u];
  }return n;
}function t(t) {
  var u = [];function r(n) {
    for (var t = [], r = 0; r < u.length; r++) {
      u[r] === n ? n = null : t.push(u[r]);
    }u = t;
  }function e(r, e, o) {
    t = e ? r : n(n({}, t), r);for (var f = u, i = 0; i < f.length; i++) {
      f[i](t, o);
    }
  }return t = t || {}, { action: function action(n) {
      function u(t) {
        e(t, !1, n);
      }return function () {
        for (var r = arguments, e = [t], o = 0; o < arguments.length; o++) {
          e.push(r[o]);
        }var f = n.apply(this, e);null != f && (f.then ? f.then(u) : u(f));
      };
    }, setState: e, subscribe: function subscribe(n) {
      return u.push(n), function () {
        r(n);
      };
    }, unsubscribe: r, getState: function getState() {
      return t;
    } };
}/* harmony default export */ var unistore_es = (t);
//# sourceMappingURL=unistore.es.js.map
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__("fiaM");

// CONCATENATED MODULE: ./store/actions.js



// If actions is a function, it gets passed the store:
var actions_actions = function actions(store) {
  return {
    //Actions receive current state as first parameter and any other params next
    //check this function as <button onClick={incrementAndLog}>
    incrementAndLog: function incrementAndLog(_ref, args) {
      var count = _ref.count;

      console.info("incrementAndLog apalah: ", args);
      return { count: count + 1 };
    },

    // Async actions can be pure async/promise functions:
    getRSSFeed: function getRSSFeed(state) {
      return new Promise(function ($return, $error) {
        var feedURL, res, resfeeds, listRSSwwwid;

        feedURL = "https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fmedium.com%2Ffeed%2Fwwwid";
        return Promise.resolve(fetch(feedURL)).then(function ($await_1) {
          try {
            res = $await_1;

            return Promise.resolve(res.json()).then(function ($await_2) {
              try {
                resfeeds = $await_2;
                if (resfeeds.status === "ok" && resfeeds.hasOwnProperty("items")) {
                  listRSSwwwid = resfeeds.items.map(function (item) {
                    return {
                      id: Object(helper["c" /* getId */])(item.guid),
                      slug: Object(helper["e" /* titleToSlug */])(item.title),
                      title: item.title,
                      pubDate: item.pubDate,
                      author: item.author,
                      thumbnail: Object(helper["a" /* getCloudinaryImage */])(item.thumbnail),
                      categories: item.categories.map(function (category, index) {
                        return {
                          id: index,
                          slug: category,
                          title: Object(helper["d" /* slugToTitle */])(category)
                        };
                      }),
                      excerpt: Object(helper["b" /* getExcerpt */])(item.description, 300),
                      description: item.description
                    };
                  });
                  return $return({ listRSSwwwid: listRSSwwwid, loadingRSSFeed: false });
                }
                return $return();
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }.bind(this), $error);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }.bind(this));
    },


    // ... or just actions that call store.setState() later:
    incrementAsync: function incrementAsync(state) {
      setTimeout(function () {
        store.setState({ count: state.count + 1 });
      }, 100);
    },


    // signin process
    signin: function signin(state) {
      return { login: true };
    },


    showModal: function showModal(state) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var content = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

      // console.log("toggleModal state: ", state);
      // console.log("toggleModal title: ", title);
      // console.log("toggleModal content:", content);
      if (title !== "" || content !== "") {
        return { modalActive: true, modalTitle: title, modalContent: content };
      } else {
        return { modalActive: true };
      }
    },

    hideModal: function hideModal() {
      return { modalActive: false };
    },

    toggleDrawer: function toggleDrawer(state) {
      return { drawerActive: !state.drawerActive };
    },

    hideDrawer: function hideDrawer(state) {
      return { drawerActive: false };
    }
  };
};

/* harmony default export */ var store_actions = __webpack_exports__["a"] = (actions_actions);

/***/ }),

/***/ "fiaM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export host */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return titleToSlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return slugToTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getExcerpt; });
/* unused harmony export getAllCategories */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCloudinaryImage; });
var host = "https://preact-wwwidpwa.netlify.com";

var getId = function getId(str) {
  var string = str.split("/");
  return string[string.length - 1];
};

var titleToSlug = function titleToSlug(str) {
  var string = str;
  string = string.replace(/^\s+|\s+$/g, ""); // trim
  string = string.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to = "aaaaeeeeiiiioooouuuunc------";

  for (var i = 0, l = from.length; i < l; i += 1) {
    string = string.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  string = string.replace(/[^a-z0-9 -]/g, "") // remove invalid chars
  .replace(/\s+/g, "-") // collapse whitespace and replace by -
  .replace(/-+/g, "-"); // collapse dashes

  return string;
};

var slugToTitle = function slugToTitle(slug) {
  var words = slug.split("-");

  for (var i = 0; i < words.length; i += 1) {
    var word = words[i];
    words[i] = word.charAt(0).toUpperCase() + word.slice(1);
  }

  return words.join(" ");
};

var getExcerpt = function getExcerpt(text) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var except = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "...";

  var content = text;
  content = content.split(/<\s*p[^>]*>([^<]*)<\s*\/\s*p\s*>/);
  content = content.filter(function (v) {
    return v.length > 100;
  });
  content = content[0].replace(/<[^>]+>/g, "");
  return content.substring(0, limit) + except;
};

var getAllCategories = function getAllCategories(params) {
  var _ref;

  var items = params;
  var categories = items.map(function (item) {
    return item.categories;
  });
  categories = (_ref = []).concat.apply(_ref, categories);
  var setCategories = new Set(categories);
  var sorted = Array.from(setCategories).sort();
  var objects = sorted.map(function (item, index) {
    return {
      id: index,
      slug: item,
      title: slugToTitle(item)
    };
  });

  return objects;
};

var getCloudinaryImage = function getCloudinaryImage(img) {
  var widthSize = void 0;
  var heightSize = void 0;

  if (window.screen.width >= 860) {
    widthSize = 330;
    heightSize = 186;
  } else if (window.screen.width >= 360 && window.screen.width < 860) {
    widthSize = 330;
    heightSize = 186;
  } else {
    widthSize = 96;
    heightSize = 54;
  }

  var fetchUrl = "https://res.cloudinary.com/azulkipli/image/fetch/c_fill,g_auto:face,h_" + heightSize + ",w_" + widthSize + ",fl_force_strip.progressive/f_webp/";

  return fetchUrl + img;
};

/***/ }),

/***/ "jrcW":
/***/ (function(module, exports, __webpack_require__) {

var n = __webpack_require__("KM04");function t(n, t) {
  "function" == typeof n && (n = n(t));var r = {};for (var e in n) {
    r[e] = t.action(n[e]);
  }return r;
}function r(n) {
  return "string" == typeof n && (n = n.split(/\s*,\s*/)), function (t) {
    for (var r = {}, e = 0; e < n.length; e++) {
      r[n[e]] = t[n[e]];
    }return r;
  };
}function e(n, t) {
  for (var r in t) {
    n[r] = t[r];
  }return n;
}function o(n) {
  var t = [];function r(n) {
    for (var r = [], e = 0; e < t.length; e++) {
      t[e] === n ? n = null : r.push(t[e]);
    }t = r;
  }function o(r, o, u) {
    n = o ? r : e(e({}, n), r);for (var i = t, c = 0; c < i.length; c++) {
      i[c](n, u);
    }
  }return n = n || {}, { action: function action(t) {
      function r(n) {
        o(n, !1, t);
      }return function () {
        for (var e = arguments, o = [n], u = 0; u < arguments.length; u++) {
          o.push(e[u]);
        }var i = t.apply(this, o);null != i && (i.then ? i.then(r) : r(i));
      };
    }, setState: o, subscribe: function subscribe(n) {
      return t.push(n), function () {
        r(n);
      };
    }, unsubscribe: r, getState: function getState() {
      return n;
    } };
}function u(o, u) {
  return "function" != typeof o && (o = r(o || [])), function (r) {
    function i(i, c) {
      var f = this,
          s = c.store,
          a = o(s ? s.getState() : {}, i),
          p = u ? t(u, s) : { store: s },
          h = function h() {
        var n = o(s ? s.getState() : {}, f.props);for (var t in n) {
          if (n[t] !== a[t]) return a = n, f.setState(null);
        }for (var r in a) {
          if (!(r in n)) return a = n, f.setState(null);
        }
      };this.componentDidMount = function () {
        h(), s.subscribe(h);
      }, this.componentWillUnmount = function () {
        s.unsubscribe(h);
      }, this.render = function (t) {
        return n.h(r, e(e(e({}, p), t), a));
      };
    }return (i.prototype = new n.Component()).constructor = i;
  };
}function i(n) {
  this.getChildContext = function () {
    return { store: n.store };
  };
}i.prototype.render = function (n) {
  return n.children[0];
}, exports.createStore = o, exports.Provider = i, exports.connect = u;
//# sourceMappingURL=preact.js.map

/***/ }),

/***/ "kEqy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "kvQY":
/***/ (function(module, exports) {

module.exports = function unistoreDevTools(store) {
	var extension = window.devToolsExtension || window.top.devToolsExtension;
	var ignoreState = false;

	if (!extension) {
		console.warn('Please install/enable Redux devtools extension');
		store.devtools = null;

		return store;
	}

	if (!store.devtools) {
		store.devtools = extension.connect();
		store.devtools.subscribe(function (message) {
			if (message.type === 'DISPATCH' && message.state) {
				ignoreState = message.payload.type === 'JUMP_TO_ACTION' || message.payload.type === 'JUMP_TO_STATE';
				store.setState(JSON.parse(message.state), true);
			}
		});
		store.devtools.init(store.getState());
		store.subscribe(function (state, action) {
			var actionName = action && action.name || 'setState';

			if (!ignoreState) {
				store.devtools.send(actionName, state);
			} else {
				ignoreState = false;
			}
		});
	}

	return store;
};

/***/ }),

/***/ "o6ac":
/***/ (function(module, exports, __webpack_require__) {

var t = __webpack_require__("KM04");function n(t, n) {
  "function" == typeof t && (t = t(n));var r = {};for (var e in t) {
    r[e] = n.action(t[e]);
  }return r;
}function r(t) {
  return "string" == typeof t && (t = t.split(/\s*,\s*/)), function (n) {
    for (var r = {}, e = 0; e < t.length; e++) {
      r[t[e]] = n[t[e]];
    }return r;
  };
}function e(t, n) {
  for (var r in n) {
    t[r] = n[r];
  }return t;
}function o(o, i) {
  return "function" != typeof o && (o = r(o || [])), function (r) {
    function u(u, c) {
      var f = this,
          s = c.store,
          p = o(s ? s.getState() : {}, u),
          a = i ? n(i, s) : { store: s },
          l = function l() {
        var t = o(s ? s.getState() : {}, f.props);for (var n in t) {
          if (t[n] !== p[n]) return p = t, f.setState(null);
        }for (var r in p) {
          if (!(r in t)) return p = t, f.setState(null);
        }
      };this.componentDidMount = function () {
        l(), s.subscribe(l);
      }, this.componentWillUnmount = function () {
        s.unsubscribe(l);
      }, this.render = function (n) {
        return t.h(r, e(e(e({}, a), n), p));
      };
    }return (u.prototype = new t.Component()).constructor = u;
  };
}function i(t) {
  this.getChildContext = function () {
    return { store: t.store };
  };
}i.prototype.render = function (t) {
  return t.children[0];
}, exports.connect = o, exports.Provider = i;
//# sourceMappingURL=preact.js.map

/***/ }),

/***/ "pj7R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.6b8d4.js